import produce from 'immer'
import * as C from './constants'

const notificationsReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case C.LOCAL_CREATE:
        draft.local.push(action.payload)
        break
      case C.LOCAL_REMOVE:
        draft.local.splice(action.payload, 1)
        break
      case C.SYSTEM_CREATE:
        draft.system.push(action.payload)
        break
      case C.SYSTEM_REMOVE:
        draft.system.splice(action.payload, 1)
        break
      default:
        break
    }
  })
}

export default notificationsReducer
